import { render, staticRenderFns } from "./BaseTopBar.vue?vue&type=template&id=676acce3&"
import script from "./BaseTopBar.vue?vue&type=script&lang=ts&"
export * from "./BaseTopBar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTopBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports